import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { UserRole } from '@/services/ws-permissions/src/main/resources/rest-api';
import { PermissionType } from '@/js/libs/generated/permissions/types';
import { AGENCY_ROLES, NEW_COMPANY_EXCLUDED_PERMISSIONS_SET, YALEO_SELF_BOOKING_USER_ROLES } from './constants';
import { useTokenStorage } from './hooks';
import { CombinedRole } from './types';
const AuthContext = React.createContext({});
const AuthProvider = ({ children }) => {
    const { getAuthToken } = useTokenStorage();
    const [token, setToken] = React.useState(getAuthToken);
    const [identity, setIdentity] = React.useState({
        user: undefined,
        loading: false,
        initialized: false,
    });
    const identityRoles = React.useMemo(() => {
        const user = identity?.user;
        if (!user?.id) {
            return [PermissionType.ANONYMOUS];
        }
        const isAdmin = user.userRole === UserRole.ADMIN;
        const isAgencyRelatedRoles = isAdmin || AGENCY_ROLES.some((role) => user.permissions?.includes(role));
        const isSelfBookingUser = user.permissions.some((permission) => permission === PermissionType.YALEO_SELF_BOOKING) &&
            user.permissions.every((permission) => YALEO_SELF_BOOKING_USER_ROLES.includes(permission));
        const isNewCompany = user.permissions?.every((permission) => NEW_COMPANY_EXCLUDED_PERMISSIONS_SET.has(permission));
        return [
            user.userRole,
            ...(user.permissions || []),
            ...(isAdmin && !user.permissions?.includes(PermissionType.PUBLISHER) ? [PermissionType.PUBLISHER] : []),
            ...(isAgencyRelatedRoles ? [CombinedRole.AGENCY] : []),
            ...(isSelfBookingUser ? [CombinedRole.YALEO_SELF_BOOKING_USER] : []),
            ...(isNewCompany ? [CombinedRole.NEW_COMPANY] : []),
        ].filter((role) => !!role);
    }, [identity]);
    const value = React.useMemo(() => ({
        identity,
        setIdentity,
        identityRoles,
        token,
        setToken,
    }), [identity, setIdentity, identityRoles, token, setToken]);
    return _jsx(AuthContext.Provider, { value: value, children: children });
};
export { AuthContext, AuthProvider };
